import React, { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import classNames from "classnames";

import { request } from "../../api";
import soundOff from "../../assets/svg/sound_off.svg";
import soundOn from "../../assets/svg/sound_on.svg";

const Showreel = ({ showreel }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [isHidden, setIsHidden] = useState(false);
  const updatedTime = showreel && showreel.updated_at ? new Date(showreel.updated_at).getTime() : 0;

  const videoRef = useRef();

  const { ref: observerTarget, inView } = useInView({
    threshold: 1,
  });

  return (
    <div className="wrap main-page-video">
      <button id="showreel-button" className={classNames("main-page-video__button", isHidden && "main-page-video__button_hidden")} onClick={() => {
        setIsMuted(prev => !prev)
      }}>
        {isMuted ? (
          <img
            src={soundOff}
            alt=""
            className="main-page-video__icon main-page-video__muted-icon"
          />
        ) : (
          <img
            src={soundOn}
            alt=""
            className="main-page-video__icon main-page-video__included-icon"
          />
        )}
      </button>

      {showreel.title && !showreel.hided && (
        <div className="main-page-video__container">
          <div className={"main-page-video_text show-text"}>
            <span dangerouslySetInnerHTML={{ __html: showreel.title }} />
          </div>
        </div>
      )}

      <video
        muted={isMuted}
        preload="metadata"
        ref={videoRef}
        playsInline
        autoPlay
        loop
      >
        {showreel.mp4 && showreel.mp4.url && (
          <source src={`${request}/${showreel.mp4.url}?v=${updatedTime}`} type="video/mp4" />
        )}
        {showreel.ogv && showreel.ogv.url && (
          <source src={`${request}/${showreel.ogv.url}?v=${updatedTime}`} type="video/ogg" />
        )}
        {showreel.webm && showreel.webm.url && (
          <source src={`${request}/${showreel.webm.url}?v=${updatedTime}`} type="video/webm" />
        )}
      </video>

      <div ref={observerTarget}></div>
    </div>
  );
};

export default Showreel;
